import { render } from "./App.vue?vue&type=template&id=da2ddf8e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=da2ddf8e&lang=css"
script.render = render

export default script